import React from 'react';
import {
  ANALYTICS_FULFILLMENT_MODES,
  ANALYTICS_FULFILLMENT_OPTIONS
} from 'helpers/constants/analytics';
import CheckboxMultiSelect from 'components/select/CheckboxMultiSelect';
import {
  useAnalyticsFilters,
  useAnalyticsFiltersUpdate
} from 'components/AnalyticsFilters/AnalyticsFiltersContext';

const FULFILLMENT_OPTIONS = ANALYTICS_FULFILLMENT_OPTIONS.filter(
  (option) => option.value !== ANALYTICS_FULFILLMENT_MODES.ALL
);

const AnalyticsFulfillmentPicker = () => {
  const {fulfillmentModes} = useAnalyticsFilters();
  const {setFulfillmentModes} = useAnalyticsFiltersUpdate();

  return (
    <CheckboxMultiSelect
      labelId='analytics-fulfillment-select-label'
      allLabel='All Fulfillments'
      ariaLabel='Analytics fulfillment modes'
      options={FULFILLMENT_OPTIONS}
      selected={fulfillmentModes}
      onChange={setFulfillmentModes}
    />
  );
};

export default AnalyticsFulfillmentPicker;
